<cipo-outline-field class="cipo-table-outline" [label]="tableField().label">
    <table mat-table [dataSource]="dataSource" matSort class="cipo-table" data-testid="table-field-view-table">
        @for (column of tableFields(); track $index) {
            <ng-container [matColumnDef]="column.key">
                <th
                    data-testid="table-field-view-header-cell"
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [ngStyle]="{ width: totalWidth() ? (100 / totalWidth()) * (column.width ?? 1) + '%' : 'auto' }"
                    [title]="column.label">
                    <span class="cipo--text--ellipsed">{{ columnsDictionary()[column.key] }}</span>
                </th>

                <td
                    mat-cell
                    *matCellDef="let row"
                    data-testid="table-field-view-cell"
                    class="cipo--align-content--start">
                    @if (row[column.key]) {
                        <div class="m-y-sm">
                            <cipo-text-view
                                [config]="column"
                                [readonlyConfig]="row[column.key].readonlyConfig"
                                [value]="row[column.key].value" />
                        </div>
                    }
                </td>

                <td mat-footer-cell *matFooterCellDef data-testid="table-field-view-footer-cell">
                    <p>
                        @let tableFieldValue = tableField();
                        @let aggregateValue = tableFieldValue?.aggregateValue || {};
                        @let aggregateOldValue = tableFieldValue?.aggregateOldValue || {};
                        @let valueChanged =
                            includeHistory() && aggregateValue[column.key] !== aggregateOldValue[column.key];
                        @let aggregateType = AGGREGATES[column?.aggregateId];
                        @if (aggregateType) {
                            <span data-testid="table-field-view-footer-aggregate">
                                {{ "SqlAggregateFunctionType." + aggregateType | translate }}
                            </span>
                        }
                        @if (valueChanged && aggregateOldValue[column.key]) {
                            <span class="old-value" data-testid="table-field-view-footer-old-value">
                                {{ aggregateOldValue[column.key] }}
                            </span>
                        }
                        <span
                            [ngClass]="{ 'new-value m-l-xs': valueChanged }"
                            data-testid="table-field-view-footer-new-value">
                            {{ aggregateValue[column.key] }}
                        </span>
                    </p>
                </td>
            </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
        @if (hasFooter()) {
            <tr mat-footer-row *matFooterRowDef="displayedColumns()"></tr>
        }
    </table>
</cipo-outline-field>
